<app-dynamic-text-widget
  [config]="config"
  [allowOverflow]="true"
  [text]="(time$ | async) ?? ''"></app-dynamic-text-widget>
